//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class ValidationConstants
{
	public static scraperNameMaxLength: number = 200;
	public static scraperDescriptionMaxLength: number = 1000;
	public static scraperWebPageNameMaxLength: number = 200;
	public static searchTermMaxLength: number = 400;
}
